export default __webpack_public_path__ + "static/media/about-us-bg.e710d357.jpg";